import { render } from "./InputNumber.vue?vue&type=template&id=bb4eb250&ts=true"
import script from "./InputNumber.vue?vue&type=script&lang=ts"
export * from "./InputNumber.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__